<template>
  <!--
    Outside NuxtLayout, matching Nuxt2's App.js: the route-loading overlay was a
    sibling of the layout inside #__nuxt, so it also covered bare-layout routes.
    See app/components/base/CustomLoading.vue.
  -->
  <BaseCustomLoading />
  <NuxtLayout>
    <VApp>
      <NuxtPage />
    </VApp>
  </NuxtLayout>
</template>
